import { BASE } from './index';
import axios from './http';

const work = {
    //work跟单工作台基础接口
    businessgetwork: params => axios.get(`${BASE.PRO}/api/bms/business/get/work`,  {params} ),
};

export default work;
